<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-10 col-sm-10">
                <h4>Detail Notification Blogs</h4>
              </div>
            </div>
          </div>
          <div class="card-body">
            <b-form>
              <b-row>
                <b-col class="overflow-auto" cols="6">
                  <b-form-group label="Header">
                    <b-form-input disabled v-model="v$.form.header.$model" placeholder="Fill the header" />
                      <b-form-invalid-feedback :state="!v$.form.header.$invalid" v-if="v$.form.header.$error">
                        {{ v$.form.header.$errors[0].$message }}
                      </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label="Sub Header">
                    <b-form-input disabled v-model="v$.form.sub_header.$model" placeholder="Fill the sub header" />
                     <b-form-invalid-feedback :state="!v$.form.sub_header.$invalid" v-if="v$.form.sub_header.$error">
                      {{ v$.form.sub_header.$errors[0].$message }}
                     </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label="Description">
                    <wysiwyg class="wysiwyg-disabled overflow-auto" v-model="v$.form.description.$model" placeholder="Fill the description" />
                    <b-form-invalid-feedback :state="!v$.form.description.$invalid" v-if="v$.form.description.$error">
                      {{ v$.form.description.$errors[0].$message }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col cols="2">
                  <b-form-group label="Published At">
                    <el-date-picker
                      disabled
                      v-model="v$.form.published_at.$model"
                      class="w-100"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm"
                      placeholder="Select date and time">
                    </el-date-picker>
                  </b-form-group>

                  <b-form-group label="Published Stop">
                    <el-date-picker
                      disabled
                      v-model="v$.form.published_stop.$model"
                      type="datetime"
                      class="w-100"
                      format="yyyy-MM-dd HH:mm"
                      placeholder="Select date and time"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </b-form-group>

                  <b-form-group label="Tags">
                    <el-select class="w-100" disabled v-model="v$.form.tags.$model" placeholder="Select">
                      <el-option
                        v-for="item in tags"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                    <b-form-invalid-feedback :state="!v$.form.tags.$invalid" v-if="v$.form.tags.$error">
                      {{ v$.form.tags.$errors[0].$message }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <!-- WAP-407 — CTA announcement, sumbu terpisah dari Tags. -->
                  <b-form-group label="Call to Action">
                    <el-select class="w-100" disabled v-model="v$.form.cta_type.$model" placeholder="Select">
                      <el-option
                        v-for="item in cta_types"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </b-form-group>

                  <b-form-group label="Banner Tone" v-if="form.tags === 'Banner'">
                    <el-select class="w-100" disabled v-model="v$.form.banner_tone.$model" placeholder="Select">
                      <el-option
                        v-for="item in banner_tones"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </b-form-group>

                  <template v-if="form.cta_type === 'url'">
                    <b-form-group label="Button Link">
                      <b-form-input disabled v-model="v$.form.cta_url.$model" placeholder="https://..." />
                    </b-form-group>
                    <b-form-group label="Button Label">
                      <b-form-input disabled v-model="v$.form.cta_label_primary.$model" placeholder="Default label" />
                    </b-form-group>
                  </template>

                  <template v-if="form.cta_type === 'rsvp'">
                    <b-form-group label="Question" v-if="form.cta_question">
                      <b-form-input disabled v-model="v$.form.cta_question.$model" />
                    </b-form-group>
                    <b-form-group label="Button Label - Interested">
                      <b-form-input disabled v-model="v$.form.cta_label_primary.$model" placeholder="Default label" />
                    </b-form-group>
                    <b-form-group label="Button Label - Not Interested">
                      <b-form-input disabled v-model="v$.form.cta_label_secondary.$model" placeholder="Default label" />
                    </b-form-group>
                  </template>

                  <template v-if="form.cta_type === 'poll'">
                    <b-form-group label="Question">
                      <b-form-input disabled v-model="v$.form.cta_question.$model" />
                    </b-form-group>
                    <b-form-group label="Options">
                      <div
                        v-for="(option, index) in form.cta_options"
                        :key="index"
                        class="border rounded p-2 mb-2 d-flex"
                      >
                        <img
                          v-if="option.image_url"
                          :src="option.image_url"
                          class="rounded mr-3"
                          style="width: 96px; height: 54px; object-fit: cover"
                        />
                        <div class="flex-grow-1">
                          <strong class="d-block">{{ option.label }}</strong>
                          <small v-if="option.description" class="text-muted d-block">
                            {{ option.description }}
                          </small>
                          <!--
                            Isi Learn more tidak ditampilkan penuh di sini — HTML-nya bisa
                            panjang dan halaman ini cuma untuk memastikan konfigurasinya benar.
                          -->
                          <small v-if="option.content" class="text-success">
                            Punya konten Learn more
                          </small>
                          <small v-else class="text-muted font-italic">
                            Tanpa konten Learn more
                          </small>
                        </div>
                      </div>
                    </b-form-group>
                  </template>

                  <b-button
                    v-if="['rsvp', 'poll'].includes(form.cta_type)"
                    class="mb-3"
                    variant="outline-primary"
                    @click="$router.push({ name: 'Notification Blogs Responses', params: { id: $route.params.id } })"
                  >
                    View responses
                  </b-button>

                  <b-form-group label="Upload Attachment">
                   <b-form-file
                      disabled
                      @input="onChangeUploadFile"
                      class="w-100"
                      v-model="v$.form.attachment.$model"
                      accept=".mp4, .pdf"
                      placeholder="Choose an video..."
                      browse-text="Browse"
                    ></b-form-file>
                  </b-form-group>
                  <p class="mb-3">{{ attachmentName }}</p>
                </b-col>

                <b-col cols="4">
                  <div class="border-left ml-4 p-3">
                    <h3 class="mb-2">{{ form.header }}</h3>
                    <p class="h4 font-weight-normal mb-4">{{ form.sub_header }}</p>
                    <div v-if="form.description !== ''" class="preview-content" v-html="form.description">
                  </div>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import moment from 'moment';
import blogsNotifApi from '../../api/blogNotif';
import popupErrorMessages from '../../library/popup-error-messages';

export default {
  name: 'Detail Notification Blogs',
  metaInfo: {
    title: 'Detail Notification Blogs',
  },
  data() {
    return {
      moment,
      loading: {
        detail: false,
      },
      form: {
        header: '',
        sub_header: '',
        description: '',
        tags: 'News',
        cta_type: 'none',
        cta_question: '',
        cta_options: [],
        cta_label_primary: '',
        cta_label_secondary: '',
        cta_url: '',
        banner_tone: 'info',
        published_at: '',
        published_stop: '',
        attachment: '',
      },
      tags: ['News', 'Announcement', 'Banner'],
      cta_types: [
        { value: 'none', label: 'No action' },
        { value: 'rsvp', label: 'RSVP (Interested / Not Interested)' },
        { value: 'poll', label: 'Poll (one question, several choices)' },
        { value: 'url', label: 'Link button' },
      ],
      banner_tones: [
        { value: 'info', label: 'Info (neutral)' },
        { value: 'live', label: 'Live (attention)' },
      ],
      loader: null,
      loaderStack: 0,
    };
  },
  validations() {
    return {
      form: {
        header: { required },
        sub_header: { required },
        description: { required },
        tags: { required },
        cta_type: {},
        cta_question: {},
        cta_options: {},
        cta_label_primary: {},
        cta_label_secondary: {},
        cta_url: {},
        banner_tone: {},
        published_at: { required },
        published_stop: {},
        attachment: {},
      },
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  computed: {
    userProfile() {
      return this.$store.state.auth.userProfile || {};
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    checkPermission() {
      const users = this.$store.state.backOffice.userProfile;
      const path = this.$router.currentRoute.fullPath;
      const permission = users.permissions.find((v) => path.includes(v.path));
      return permission.configuration;
    },
    attachmentName() {
      const att = this.form.attachment;
      if (!att) return '';
      if (att instanceof File) {
        return att.name;
      }
      if (typeof att === 'string') {
        try {
          const url = new URL(att);
          return url.pathname.split('/').pop();
        } catch {
          return att;
        }
      }
      return '';
    },
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    async getDetail() {
      this.loading.detail = true;
      const { id } = this.$route.params;
      await blogsNotifApi.getDetail(id).then(async (response) => {
        await popupErrorMessages(response);
        const {
          header,
          sub_header,
          tags,
          description,
          published_at,
          published_stop,
          cta_type,
          cta_question,
          cta_options,
          cta_label_primary,
          cta_label_secondary,
          cta_url,
          banner_tone,
        } = response.data;
        this.form.header = header;
        this.form.sub_header = sub_header;
        this.form.description = description;
        this.form.tags = tags;
        // Record lama tidak punya field ini sama sekali, jadi semuanya perlu fallback.
        this.form.cta_type = cta_type || 'none';
        this.form.cta_question = cta_question || '';
        this.form.cta_options = Array.isArray(cta_options) ? cta_options : [];
        this.form.cta_label_primary = cta_label_primary || '';
        this.form.cta_label_secondary = cta_label_secondary || '';
        this.form.cta_url = cta_url || '';
        this.form.banner_tone = banner_tone || 'info';
        this.form.published_at = published_at;
        this.form.published_stop = published_stop;
        const match = description.match(/https?:\/\/[^\s'"]+\.(pdf|mp4)/i);
        this.form.attachment = match ? match[0] : '';
      });
      this.loading.detail = false;
    },
    onChangeUploadFile(file) {
      if (!file) return;
      const fileUrl = URL.createObjectURL(file);
      const isVideo = file.type.includes('video');
      const isPdf = file.type === 'application/pdf';
      // 🧹 Remove ALL existing video + PDF tags before adding new
      this.form.description = this.form.description
        .replace(/<video[\s\S]*?<\/video>/gi, '')
        .replace(/<a[^>]*href="[^"]*"[^>]*>[^<]*<\/a>/gi, '');
      if (isVideo) {
        const videoTag = `<video src="${fileUrl}" controls class="mt-3 w-100" style="max-height: 300px;"></video><br />`;
        this.form.description += videoTag;
      }
      if (isPdf) {
        const pdfTag = `<a href="${fileUrl}" target="_blank" class="mt-3 d-block text-primary">View PDF</a><br />`;
        this.form.description += pdfTag;
      }
    },
  },
};
</script>
<style>
  .wysiwyg-disabled .editor,
  .wysiwyg-disabled [contenteditable="true"] {
    pointer-events: none;
    background: #f5f5f5; /* gray background to indicate disabled */
  }

  .preview-content img, .preview-content video {
    max-width: 100%;
    height: auto;
    max-height: 200px;
    object-fit: contain;
    display: block;
  }
  .preview-content table {
    width: 100%;
    border-collapse: collapse;
  }
  .preview-content table td,
  .preview-content table th {
    border: 1px solid #ccc;
    padding: 8px;
    color: #000;
    font-family: "Open Sans", Arial, sans-serif;
    text-align: left;
  }
</style>
